// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {  endPoints } from '../../apis/apiEndPoints';
import { MasterDataType, UserDataType } from '../../types/dataTypes';

const DOMAIN = window.location.origin

export const locationApi = createApi({
    reducerPath: 'locationApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${DOMAIN}`
    }),
    endpoints: (builder) => ({
        getLocationList: builder.query({
            query: (userData: MasterDataType) => ({
                url: `${endPoints.LOCATION_LIST}`,
                method: 'GET',
                params: {
                    "channelId": userData.channelId,
                    "subChannelId": userData.subChannelId,
                    "random": userData.recruiterId
                },
                headers: {
                    'domain': DOMAIN,
                },
                withCredentials: true,

            }),
            transformResponse: (data: any) => {
                let locationObj: any = []

                if (data && data['topCities']) {
                    locationObj.push({
                        id: 'topCities',
                        label: 'Top Cities',
                        count: data['topCities'].length,
                        parentId: 0,
                        isPillData: false,
                        next: true
                    })

                    data['topCities'].forEach((topCities: any) => {
                        if (topCities) {
                            locationObj.push({
                                id: topCities.id,
                                label: topCities.value,
                                count: 0,
                                parentId: 'topCities',
                                isPillData: true,
                                next: false
                            })
                        }
                    })
                }

                if (data && data['regionAndStates']) {
                    locationObj.push({
                        id: 'Region',
                        label: 'Region And States',
                        count: data['regionAndStates'].length,
                        parentId: 0,
                        isPillData: false,
                        next: true
                    })

                    data['regionAndStates'].forEach((regionAndStates: any) => {
                        if (regionAndStates) {
                            locationObj.push({
                                id: 'Region' + regionAndStates.id,
                                label: regionAndStates.name,
                                count: regionAndStates.cities.length,
                                parentId: 'Region',
                                isPillData: false,
                                next: true
                            })

                            if (regionAndStates.cities) {
                                regionAndStates.cities.forEach((city: any) => {
                                    if (city) {
                                        locationObj.push({
                                            label: city.value,
                                            id: city.id,
                                            parentId: 'Region' + regionAndStates.id,
                                            next: false,
                                            count: 0,
                                            isPillData: true,
                                            grandParentId: 'Region',
                                        })
                                    }
                                })
                            }
                        }
                    })
                }

                if (data && data['internationalLocations']) {
                    locationObj.push({
                        id: 'internationalLocations',
                        label: 'International Locations',
                        count: data['internationalLocations'].length,
                        parentId: 0,
                        isPillData: false,
                        next: true
                    })

                    data['internationalLocations'].forEach((intLocation: any) => {
                        if (intLocation) {
                            locationObj.push({
                                id: intLocation.id,
                                label: intLocation.value,
                                count: 0,
                                parentId: 'internationalLocations',
                                isPillData: true,
                                next: false
                            })
                        }
                    })
                }

                return locationObj
            }
        })

    }),
})

export const {
    useLazyGetLocationListQuery,

} = locationApi;

